var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "carousel_items  wow fadeInUp catalog_page__filter",
      attrs: { "data-wow-delay": "0.7s" },
    },
    [
      _c(
        "agile",
        {
          staticClass: "catalog_page__filter_contents",
          attrs: { "initial-slide": 0, options: _vm.options_main_slider },
        },
        [
          _vm._l(_vm.items, function (item, index) {
            return _c(
              "div",
              {
                staticClass:
                  "slide filter_contents__item mb-0 market  position-relative",
              },
              [
                _c("div", { staticClass: "bar_item__content h-100" }, [
                  _c("div", { staticClass: "item_plain h-100" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex h-100 item_plain__content item_polls flex-column",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "market__img d-flex justify-content-center",
                          },
                          [_c("img", { attrs: { src: item.img } })]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "w-100 h-100 justify-content-between flex-column d-flex item_plain__descr",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "item_plain__title flex-grow-1" },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(item.name) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("a", {
                  staticClass: "w-100 position-absolute h-100 l-0 t-0 zi-1",
                  attrs: { href: item.url },
                }),
              ]
            )
          }),
          _vm._v(" "),
          _c("template", { slot: "prevButton" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "19",
                  height: "18",
                  viewBox: "0 0 19 18",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M11.5 4.5L7 9L11.5 13.5",
                    stroke: "white",
                    "stroke-width": "2.4",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("template", { slot: "nextButton" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "19",
                  height: "18",
                  viewBox: "0 0 19 18",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M7.5 13.5L12 9L7.5 4.5",
                    stroke: "white",
                    "stroke-width": "2.4",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
              ]
            ),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }